import { render, staticRenderFns } from "./SetQtyCapital.vue?vue&type=template&id=ad3051b4&scoped=true&"
import script from "./SetQtyCapital.vue?vue&type=script&lang=js&"
export * from "./SetQtyCapital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3051b4",
  null
  
)

export default component.exports